import { useEffect, useState } from "react";
import type { AuthConfigResponse } from "@tw-pulse/shared";
import { api } from "./api";

/**
 * Fetches /v1/auth/config once. Returns `null` while loading, then the
 * provider availability map. The web bundle never sees Google credentials —
 * we just learn whether to render the button.
 */
export function useAuthConfig(): AuthConfigResponse | null {
  const [config, setConfig] = useState<AuthConfigResponse | null>(null);
  useEffect(() => {
    let cancelled = false;
    api
      .config()
      .then((c) => {
        if (!cancelled) setConfig(c);
      })
      .catch(() => {
        if (!cancelled) setConfig({ google: { enabled: false } });
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return config;
}
